import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-20980ef8")

_pushScopeId("data-v-20980ef8")
const _hoisted_1 = { class: "qr-code-styling" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("QR "),
  /*#__PURE__*/_createVNode("a", { href: "https://matiasvaldivia.com.ar" }, "matiasvaldivia.com.ar")
], -1)
const _hoisted_3 = {
  id: "qr-code",
  ref: "qrCode"
}
const _hoisted_4 = { class: "settings" }
const _hoisted_5 = { class: "main-options" }
const _hoisted_6 = { class: "setting-input" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "data" }, "Data:", -1)
const _hoisted_8 = { class: "setting-input" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "image" }, "Image File:", -1)
const _hoisted_10 = { class: "setting-input" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "width" }, "Width:", -1)
const _hoisted_12 = { class: "setting-input" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "height" }, "Height:", -1)
const _hoisted_14 = { class: "setting-input" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "margin" }, "Margin:", -1)
const _hoisted_16 = { class: "dots-options" }
const _hoisted_17 = /*#__PURE__*/_createVNode("h3", null, "Dots Options", -1)
const _hoisted_18 = { class: "setting-input" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { for: "dots-style" }, "Dots Style:", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("option", { value: "rounded" }, "Rounded", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("option", { value: "square" }, "Square", -1)
const _hoisted_22 = { class: "setting-input" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "dots-color" }, "Dots Color:", -1)
const _hoisted_24 = { class: "corner-square-options" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h3", null, "Corner Square Options", -1)
const _hoisted_26 = { class: "setting-input" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { for: "corner-square-style" }, "Corner Square Style:", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("option", { value: "rounded" }, "Rounded", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("option", { value: "extra-rounded" }, "Extra Rounded", -1)
const _hoisted_30 = { class: "setting-input" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { for: "corner-square-color" }, "Corner Square Color:", -1)
const _hoisted_32 = { class: "corner-dots-options" }
const _hoisted_33 = /*#__PURE__*/_createVNode("h3", null, "Corner Dots Options", -1)
const _hoisted_34 = { class: "setting-input" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { for: "corner-dot-style" }, "Corner Dot Style:", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("option", { value: "rounded" }, "Rounded", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("option", { value: "extra-rounded" }, "Extra Rounded", -1)
const _hoisted_38 = { class: "setting-input" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", { for: "corner-dot-color" }, "Corner Dot Color:", -1)
const _hoisted_40 = { class: "background-options" }
const _hoisted_41 = /*#__PURE__*/_createVNode("h3", null, "Background Options", -1)
const _hoisted_42 = { class: "setting-input" }
const _hoisted_43 = /*#__PURE__*/_createVNode("label", { for: "background-color" }, "Background Color:", -1)
const _hoisted_44 = { class: "image-options" }
const _hoisted_45 = /*#__PURE__*/_createVNode("h3", null, "Image Options", -1)
const _hoisted_46 = { class: "setting-input" }
const _hoisted_47 = /*#__PURE__*/_createVNode("label", { for: "hide-background-dots" }, "Hide Background Dots:", -1)
const _hoisted_48 = { class: "setting-input" }
const _hoisted_49 = /*#__PURE__*/_createVNode("label", { for: "image-size" }, "Image Size:", -1)
const _hoisted_50 = { class: "setting-input" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", { for: "image-margin" }, "Image Margin:", -1)
const _hoisted_52 = { class: "qr-options" }
const _hoisted_53 = /*#__PURE__*/_createVNode("h3", null, "QR Options", -1)
const _hoisted_54 = { class: "setting-input" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { for: "type-number" }, "Type Number:", -1)
const _hoisted_56 = { class: "setting-input" }
const _hoisted_57 = /*#__PURE__*/_createVNode("label", { for: "error-correction-level" }, "Error Correction Level:", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("option", { value: "L" }, "L - Low", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("option", { value: "M" }, "M - Medium", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("option", { value: "Q" }, "Q - Quartile", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("option", { value: "H" }, "H - High", -1)
const _hoisted_62 = { class: "export-options" }
const _hoisted_63 = { class: "setting-input" }
const _hoisted_64 = /*#__PURE__*/_createVNode("label", { for: "download-extension" }, "Download As:", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("option", { value: "svg" }, "SVG", -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("option", { value: "png" }, "PNG", -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("option", { value: "jpeg" }, "JPEG", -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("option", { value: "webp" }, "WEBP", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, null, 512),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createVNode("input", {
            type: "text",
            id: "data",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.options.data = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.data]
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("input", {
            type: "file",
            id: "image",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageChange && _ctx.onImageChange(...args)))
          }, null, 32)
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createVNode("input", {
            type: "number",
            id: "width",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.options.width = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.width]
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createVNode("input", {
            type: "number",
            id: "height",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.options.height = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.height]
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createVNode("input", {
            type: "number",
            id: "margin",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.options.margin = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.margin]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createVNode("select", {
            id: "dots-style",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.options.dotsOptions.type = $event))
          }, [
            _hoisted_20,
            _hoisted_21
          ], 512), [
            [_vModelSelect, _ctx.options.dotsOptions.type]
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createVNode("input", {
            type: "color",
            id: "dots-color",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.options.dotsOptions.color = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.dotsOptions.color]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode("div", _hoisted_26, [
          _hoisted_27,
          _withDirectives(_createVNode("select", {
            id: "corner-square-style",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.options.cornersSquareOptions.type = $event))
          }, [
            _hoisted_28,
            _hoisted_29
          ], 512), [
            [_vModelSelect, _ctx.options.cornersSquareOptions.type]
          ])
        ]),
        _createVNode("div", _hoisted_30, [
          _hoisted_31,
          _withDirectives(_createVNode("input", {
            type: "color",
            id: "corner-square-color",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.options.cornersSquareOptions.color = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.cornersSquareOptions.color]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_32, [
        _hoisted_33,
        _createVNode("div", _hoisted_34, [
          _hoisted_35,
          _withDirectives(_createVNode("select", {
            id: "corner-dot-style",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.options.cornersDotOptions.type = $event))
          }, [
            _hoisted_36,
            _hoisted_37
          ], 512), [
            [_vModelSelect, _ctx.options.cornersDotOptions.type]
          ])
        ]),
        _createVNode("div", _hoisted_38, [
          _hoisted_39,
          _withDirectives(_createVNode("input", {
            type: "color",
            id: "corner-dot-color",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.options.cornersDotOptions.color = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.cornersDotOptions.color]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_40, [
        _hoisted_41,
        _createVNode("div", _hoisted_42, [
          _hoisted_43,
          _withDirectives(_createVNode("input", {
            type: "color",
            id: "background-color",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.options.backgroundOptions.color = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.backgroundOptions.color]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_44, [
        _hoisted_45,
        _createVNode("div", _hoisted_46, [
          _hoisted_47,
          _withDirectives(_createVNode("input", {
            type: "checkbox",
            id: "hide-background-dots",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.options.imageOptions.hideBackgroundDots = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.options.imageOptions.hideBackgroundDots]
          ])
        ]),
        _createVNode("div", _hoisted_48, [
          _hoisted_49,
          _withDirectives(_createVNode("input", {
            type: "number",
            id: "image-size",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.options.imageOptions.imageSize = $event)),
            min: "0",
            max: "1",
            step: "0.01"
          }, null, 512), [
            [_vModelText, _ctx.options.imageOptions.imageSize]
          ])
        ]),
        _createVNode("div", _hoisted_50, [
          _hoisted_51,
          _withDirectives(_createVNode("input", {
            type: "number",
            id: "image-margin",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.options.imageOptions.margin = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.imageOptions.margin]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_52, [
        _hoisted_53,
        _createVNode("div", _hoisted_54, [
          _hoisted_55,
          _withDirectives(_createVNode("input", {
            type: "number",
            id: "type-number",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.options.qrOptions.typeNumber = $event))
          }, null, 512), [
            [_vModelText, _ctx.options.qrOptions.typeNumber]
          ])
        ]),
        _createVNode("div", _hoisted_56, [
          _hoisted_57,
          _withDirectives(_createVNode("select", {
            id: "error-correction-level",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.options.qrOptions.errorCorrectionLevel = $event))
          }, [
            _hoisted_58,
            _hoisted_59,
            _hoisted_60,
            _hoisted_61
          ], 512), [
            [_vModelSelect, _ctx.options.qrOptions.errorCorrectionLevel]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_62, [
        _createVNode("div", _hoisted_63, [
          _hoisted_64,
          _withDirectives(_createVNode("select", {
            id: "download-extension",
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.extension = $event))
          }, [
            _hoisted_65,
            _hoisted_66,
            _hoisted_67,
            _hoisted_68
          ], 512), [
            [_vModelSelect, _ctx.extension]
          ])
        ]),
        _createVNode("button", {
          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args)))
        }, "Download")
      ])
    ])
  ]))
})